import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-valid-field-info',
  templateUrl: './valid-field-info.component.html',
  styleUrls: ['./valid-field-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidFieldInfoComponent implements AfterViewInit {
  @Input() control!: any;

  @Input() set extraValid(state: unknown) {
    const next = !!state;
    if (next === this.extraValidState) {
      return;
    }
    this.extraValidState = next;
    this.updateValidState();
  }

  extraValidState = true;
  isValid = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.subscribeOnChanges();
    });
  }

  private subscribeOnChanges(): void {
    this.updateValidState();
    if (!this.control) {
      return;
    }

    this.control.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.updateValidState();
    });
  }

  private updateValidState(): void {
    const next =
      !!this.control?.value && !!this.control?.valid && this.extraValidState;
    if (next === this.isValid) {
      return;
    }
    this.isValid = next;
    this.cdr.markForCheck();
  }
}
